import msg from 'msg';

export default pageParameters =>
  (pageParameters.shortDescription
    ? `${msg.page.offerDetailsPrefix}${pageParameters.shortDescription}${msg.page.titleSuffix}`
    : msg.page.title
  );
